<template>
  <div class="process-indicator">
    <span class="title-fases" >Process</span>
    <div class="carousel-wrapper" data-v-step="8" >
      <div class="btn-slide" @click="moveCarousel(-1)" :disabled="atHeadOfList">
        <font-awesome-icon icon="caret-left" />
      </div>
      <div class="carosel-overflow">
        <div
          class="carousel-content"
          :style="{
            transform: 'translateX' + '(' + currentOffset + 'px' + ')',
          }"
        >
          <CardProcessVue v-for="(item,index) in getPhaseSelected.process" :key="index" :data="item" />
        </div>
      </div>
      <div class="btn-slide" @click="moveCarousel(1)" :disabled="atEndOfList">
        <font-awesome-icon icon="caret-right" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters,mapMutations } from 'vuex';
import CardProcessVue from "./CardProcess.vue";

export default {
  components: {
    CardProcessVue,
  },
  data: () => ({
    currentOffset: 0,
    windowSize: 5,
    paginationFactor: 210,
  }),
  computed: {
    ...mapGetters(["getPhaseSelected"]),
    atEndOfList() {
      return (
        this.currentOffset <=
        this.paginationFactor * -1 * (this.getPhaseSelected.process.length - this.windowSize)
      );
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
  },
  watch:{
    getPhaseSelected(newPhase){
      this.refactorWindow(true);
      this.currentOffset = 0;
      this.setProcessSelected(newPhase.process[0].id)
    }
  },
  methods: {
    ...mapMutations(["setProcessSelected"]),
    refactorWindow() {
      const spaceSize = document.getElementsByClassName("carosel-overflow")[0]
        .offsetWidth;

      this.windowSize = Math.trunc(spaceSize / this.paginationFactor)+1;
    },
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList) {
        this.currentOffset -= this.paginationFactor;
      } else if (direction === -1 && !this.atHeadOfList) {
        this.currentOffset += this.paginationFactor;
      }
    },
  },
  mounted() {
    this.refactorWindow(true);
    window.addEventListener("resize", this.refactorWindow);
  },
  destroyed() {
    window.removeEventListener("resize", this.refactorWindow);
  }
};
</script>

<style  scoped>
.process-indicator {
  
  display: flex;
  flex-direction: column;
  font-family: "Montserrat", sans-serif;
}
.process-indicator .title-fases {
  font-size: .8rem;
  color:var(--fifth-color);
  font-family: "Montserrat", sans-serif;
  font-weight: bold;
}

.carousel-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
}
.carosel-overflow {
  display: flex;
  justify-content: flex-start;
  overflow: hidden;
  width: 100%;
}

.carousel-content {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);
  padding: 15px 0;
}
</style>